import { render, staticRenderFns } from "./OpenSeadragon.vue?vue&type=template&id=465ff080&scoped=true&"
import script from "./OpenSeadragon.vue?vue&type=script&lang=js&"
export * from "./OpenSeadragon.vue?vue&type=script&lang=js&"
import style0 from "./OpenSeadragon.vue?vue&type=style&index=0&id=465ff080&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "465ff080",
  null
  
)

export default component.exports